import {BaseDomainModel} from "../../../../../../infrastructure/models/base-domain-model";
import {AtsRecordsRowValueApiModel} from "./ats-records.row-value.api-model";

export class AtsRecordsRowValueDomainModel extends BaseDomainModel {
  apiModel: AtsRecordsRowValueApiModel;

  get columnId(): Number {
    return this.apiModel.col;
  }

  get value(): String {
    return this.apiModel.val;
  }
}
